import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import PatientDashboard from './pages/PatientDashboard';
import DoctorDashboard from './pages/DoctorDashboard';
import AdminDashboard from './pages/AdminDashboard';
import CaseSubmission from './pages/CaseSubmission';
import CaseDetail from './pages/CaseDetail';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import DoctorApplication from './pages/DoctorApplication';
import DoctorDirectory from './pages/DoctorDirectory';
import BookVideoConsultation from './pages/BookVideoConsultation';
import VideoConsultationRoom from './pages/VideoConsultationRoom';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsOfUse from './pages/legal/TermsOfUse';
import MedicalDisclaimer from './pages/legal/MedicalDisclaimer';
import RefundPolicy from './pages/legal/RefundPolicy';
import AboutUs from './pages/legal/AboutUs';
import ContactUs from './pages/legal/ContactUs';
import GrievanceRedressal from './pages/legal/GrievanceRedressal';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import AdminBlogManager from './pages/AdminBlogManager';
import DoctorPractice from './pages/DoctorPractice';
import PublicDoctorProfile from './pages/PublicDoctorProfile';
import SpecialtyPage from './pages/SpecialtyPage';
import SpecialtiesIndex from './pages/SpecialtiesIndex';
import SeoManager from './components/SeoManager';
import './App.css';

// Google Analytics SPA route-change tracker
function GAPageTracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('config', 'G-NBZKWX8P7S', {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <GAPageTracker />
        <SeoManager />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          
          <Route path="/patient/*" element={
            <ProtectedRoute allowedRoles={['patient']}>
              <PatientDashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/doctor/*" element={
            <ProtectedRoute allowedRoles={['doctor']}>
              <DoctorDashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/admin/*" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/submit-case" element={
            <ProtectedRoute allowedRoles={['patient']}>
              <CaseSubmission />
            </ProtectedRoute>
          } />
          
          <Route path="/case/:caseId" element={
            <ProtectedRoute>
              <CaseDetail />
            </ProtectedRoute>
          } />
          
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />
          <Route path="/doctors/apply" element={<DoctorApplication />} />
          <Route path="/for-doctors" element={<DoctorApplication />} />
          <Route path="/doctors" element={<DoctorDirectory />} />
          <Route path="/doctors/:doctorId/book" element={<BookVideoConsultation />} />
          <Route path="/video-consult/:consultationId" element={
            <ProtectedRoute>
              <VideoConsultationRoom />
            </ProtectedRoute>
          } />
          
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/medical-disclaimer" element={<MedicalDisclaimer />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/grievance-redressal" element={<GrievanceRedressal />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/admin/blog" element={
            <ProtectedRoute roles={['admin']}><AdminBlogManager /></ProtectedRoute>
          } />
          <Route path="/doctor/practice" element={
            <ProtectedRoute roles={['doctor']}><DoctorPractice /></ProtectedRoute>
          } />
          <Route path="/dr/:id" element={<PublicDoctorProfile />} />
          <Route path="/specialties" element={<SpecialtiesIndex />} />
          <Route path="/specialties/:slug" element={<SpecialtyPage />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;